import { MotionFlex } from '@/ui';
import { ModalContent, type ModalContentProps } from '@/ui';
import {
  MODAL_SIDEBAR_WIDTH,
  MODAL_MAX_HEIGHT,
  MODAL_VERTICAL_GUTTER,
} from '../constants';
import { useEntryModalContext } from '../contexts';

export const EntryModalContent = (props: ModalContentProps) => {
  const { activeSidebarPanel, slideSidebarUpFromBottom } =
    useEntryModalContext();

  const variants = {
    show: {
      translateX: slideSidebarUpFromBottom ? 0 : -(MODAL_SIDEBAR_WIDTH / 2),
      transition: {
        duration: 0.2,
      },
    },
    hide: {
      translateX: 0,
      transition: {
        duration: 0.2,
      },
    },
  };

  return (
    <ModalContent
      animate={activeSidebarPanel ? 'show' : 'hide'}
      as={MotionFlex}
      borderRightRadius={activeSidebarPanel ? 'none' : 'md'}
      flexDir="row"
      initial={activeSidebarPanel ? 'show' : 'hide'}
      maxW={{ base: 'calc(100vw - 18px)', md: 'none' }}
      my={0}
      overflow={{ base: 'hidden', lg: 'unset' }}
      pos="relative"
      variants={variants}
      w="auto"
      h={{
        base: 'var(--app-height)',
        md: `calc(var(--app-height) - ${MODAL_VERTICAL_GUTTER}px)`,
      }}
      maxH={{
        base: 'calc(var(--app-height) - 18px)',
        md: `${MODAL_MAX_HEIGHT}px`,
      }}
      {...props}
    />
  );
};
